import { useEffect, useState } from "react";

const KEY = "askredline.sidebarCollapsed";
const DESKTOP = "(min-width: 1024px)";

export function useSidebarCollapse() {
  const [preferred, setPreferred] = useState(() => {
    try { return localStorage.getItem(KEY) === "true"; } catch { return false; }
  });
  const [desktop, setDesktop] = useState(() => window.matchMedia(DESKTOP).matches);
  useEffect(() => {
    const media = window.matchMedia(DESKTOP);
    const onChange = (event) => setDesktop(event.matches);
    media.addEventListener("change", onChange);
    return () => media.removeEventListener("change", onChange);
  }, []);
  const toggle = () => {
    const next = !preferred;
    setPreferred(next);
    try { localStorage.setItem(KEY, String(next)); } catch { /* Browser storage may be unavailable. */ }
  };
  return [desktop && preferred, toggle];
}
